import { Link } from 'react-router-dom';
import { useGetModuleQuery } from '@platform/state/api';
import { formatDate } from '@platform/core/lib/format';
import { routes } from '@platform/core/lib/routes';
import { statusColor } from '@platform/core/lib/statusColors';
import { recordNumber } from '@platform/engine/views/recordNumber';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import type { IAssignedRowProps } from './IAssignedRowProps';

/**
 * Рядок «Призначені вам» (прототип v4): крапка кольору статусу (набір статусів типу — з визначення модуля, кешується), номер IBM Plex Mono
 * 11px у колонці 72px (голий, як у прототипі: «101»; повне позначення — у підказці), назва з «…», термін 12px приглушений; відкриває запис.
 */
export function AssignedRow({ ws, record }: IAssignedRowProps) {
  const lang = useAppSelector(selectLang);
  const { data: module } = useGetModuleQuery({ key: record.module, workspaceId: ws });
  const statuses = module?.recordTypes.find((r) => r.key === record.recordType)?.statuses;
  const due = record.due ? formatDate(record.due, lang) : '';
  return (
    <Link className="hp-row" to={routes.record(record.module, record.recordType, record.id)}>
      <span className="hp-dot" style={{ background: statuses ? statusColor(statuses, record.status, record.recordType) : 'var(--line2)' }} aria-hidden="true" />
      <span className="hp-code" title={record.display}>{recordNumber(record)}</span>
      <span className="hp-title">{record.title}</span>
      <span className="hp-due">{due}</span>
    </Link>
  );
}
